export default __webpack_public_path__ + "static/media/ChatActive.4c216c35.svg";